import { yupResolver } from '@hookform/resolvers/yup';
import { CustomButton, CustomInputCheckBox } from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';
import { IVisaBasellMeta } from '../../containers/forms/visaBasell/VisaBasellFormMeta';

type Props = {
  onSubmit: any,
  meta: IVisaBasellMeta,
  isLoading?: boolean,
  isSubmitting: boolean,
};

export const VisaBasellFormUI = ({
  meta,
  onSubmit,
  isLoading,
  isSubmitting,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box shadow={'lg'} p={'2em'} w="full" h="fit-content">
      <CC.Heading as="h1" size={'md'} mb="1%">
        Center Basell Commission Parameter
      </CC.Heading>
      <form onSubmit={handleSubmit(onSubmit)}>
        <CustomFormControl
          isLoading={isLoading}
          isInvalid={!!errors[meta.transactionCodeCheckbox.name]}
          w={'auto'}
        >
          <CustomInputCheckBox
            meta={meta.transactionCodeCheckbox}
            register={register(meta.transactionCodeCheckbox.name)}
            hasError={errors[meta.transactionCodeCheckbox.name]}
          >
            {meta.transactionCodeCheckbox.label}
          </CustomInputCheckBox>
        </CustomFormControl>
        <CC.Flex justify={'end'} mt={'1em'}>
          <CustomButton isLoading={isSubmitting} type="submit">
            <FaSave style={{ marginRight: '10px' }} /> Sauvegarder
          </CustomButton>
        </CC.Flex>
      </form>
    </CC.Box>
  );
};
